import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Landmark } from "lucide-react";

export function TaxPendingBanner() {
  const [d, setD] = useState(null);
  const navigate = useNavigate();
  useEffect(() => { api.get("/tax-tables/pending-summary").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d?.count) return null;
  return (
    <div className="rounded-xl border border-blue-300 bg-blue-50 p-4 flex items-start gap-3" data-testid="tax-pending-banner">
      <Landmark className="w-5 h-5 text-blue-700 shrink-0 mt-0.5" />
      <div className="flex-1 text-sm">
        <div className="font-semibold text-blue-900" data-testid="tax-pending-banner-title">{d.count} tax-table proposal{d.count > 1 ? "s" : ""} waiting for your approval</div>
        <p className="text-xs text-blue-800 mt-0.5">AI-refreshed rates for {d.states.join(", ")} are staged. Nothing changes in payroll until you approve them.</p>
      </div>
      <Button size="sm" variant="outline" data-testid="tax-pending-banner-go" onClick={() => navigate("/settings?tab=tax")}>Review tax tables</Button>
    </div>
  );
}
